import { PropsWithChildren } from "react";
import { MainLayoutRoot } from "./MainLayout.styles";
import AppBar from "../../navigation/AppBar/AppBar";

const MainLayout = ({ children }: PropsWithChildren<Record<string, unknown>>): JSX.Element => (
    <MainLayoutRoot>
        <AppBar />
        {children}
    </MainLayoutRoot>
);

export default MainLayout;
